/// <amd-module name="Artifacts/Upack/components/Logo" />
import { ILogoProps } from "Artifacts/Package/types/ILogoProps";
import * as UpackRes from "Artifacts/Upack/Resources";
import * as React from "react";
import { Components, useComponentContext } from "VSS/Platform/Layout";
import { getAssetLocation } from "VSS/Platform/Location";
import { Image } from "VSSUI/Image";

export const logoContributionId = "ms.azure-artifacts.protocol-upack.logo";

const Logo: React.FC<ILogoProps> = ({ className }) => {
  const { pageContext } = useComponentContext();

  return (
    <Image
      className={className}
      alt={UpackRes.Logo_UPack}
      src={getAssetLocation(
        pageContext,
        "ms.azure-artifacts/protocol-upack/img/universal-package.svg",
      )}
    />
  );
};

Components.add(logoContributionId, Logo);

export { Logo };
